import { useQuery } from "@tanstack/react-query";
import { http } from "../../../../../../services/HttpService";
import { HTTP_ENDPOINTS, QUERY_KEYS } from "../../../../../../consts/api";

export const useClinicsLoyaltyList = (options = {}) => {
  const res = useQuery(
    [QUERY_KEYS.clinicsLoyaltyList],
    () => http.get(HTTP_ENDPOINTS.getClinicLoyaltyList()),
    {
      cacheTime: 0,
      select: (res) =>
        res.data.data.map((clinic) => ({
          value: clinic.id,
          label: clinic.clinic_name,
          canPatientCancel: clinic.can_patients_cancel_subscription,
        })),
      ...options,
    },
  );

  return res;
};
